import { Button } from "@/components/ui/button";
import { Result } from "@/schema/free-assessment/Result";
import ResultRadar from "@/src/_components/ResultRadar";
import GradeCard from "@/src/free-assessment/result/_components/GradeCard";
import GradeTable from "@/src/free-assessment/result/_components/GradeTable";
import Heading from "@/src/free-assessment/result/_components/Heading.tsx";
import ScoreTable from "@/src/free-assessment/result/_components/ScoreTable";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

interface AssessmentResultProps {
  result: Result;
}

function AssessmentResult({ result }: AssessmentResultProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const calculateGrade = (score: number) => {
    if (score >= 90) return "S";
    if (score >= 80) return "A";
    if (score >= 70) return "B";
    if (score >= 50) return "C";
    return "D";
  };

  const grade = calculateGrade(result.total);

  return (
    <div className="mx-4 mt-8 sm:mx-16">
      <Heading />
      <div className="mx-auto w-full md:w-[720px] lg:w-[960px]">
        <div className="my-6 h-px bg-cool-gray-200 " />
        <div className="flex items-bottom justify-between">
          <div className="">
            <div className="flex flex-row justify-between w-full lg:basis-1/3 mb-[24px]">
              <h2 className="text-[18px] leading-[28px] font-bold text-cool-gray-900">
                {t("assessment-automatic-scoring-results")}
              </h2>
            </div>
            <div className="mb-[24px]">
              外国人雇用管理セルフアンケート診断結果は、以下の通りとなりました。今後も適正雇用に努めましょう。
              <br />
              この度の取り組みに対して修了認定証を発行します。
              <br />
              下記より認定証をダウンロードしてご利用ください。
            </div>
            <div className="mb-[24px]">
              <Button onClick={() => navigate("/free-assessment/certificate")}>
                {t("download-certificate")}
              </Button>
            </div>
          </div>
        </div>
        <div className="flex flex-col lg:flex-row gap-8 ">
          <div className="flex grow flex-col gap-6 lg:basis-2/3">
            <GradeTable grade={grade} />
            <div className="flex flex-col gap-6 md:flex-row">
              <GradeCard className="w-full" grade={grade} />
              {/* <ScoreCard className="basis-1/2" score={result.total}/> */}
            </div>
            <div>
              <ResultRadar
                data={result.categories.map(({ content, points }) => ({
                  label: content,
                  points,
                }))}
              />
            </div>
          </div>
          <div className="w-full lg:basis-1/3">
            <ScoreTable result={result} />
          </div>
        </div>
        <div className="pb-16">{t("cautionary_statement")}</div>
      </div>
    </div>
  );
}

export default AssessmentResult;
